import { 
  Wine, 
  Users, 
  Dice5,
  Hash, 
  Shuffle, 
  Palette,
  SquareCheckBig,
  Gamepad2,
  HelpCircle,
  FileText,
  Shield,
  ExternalLink
} from 'lucide-react';

// Define the possible modes for the sidebar
export type SidebarMode = 'games' | 'participants' | 'numbers' | 'random-numbers' | 'colors' | 'binary' | 'dice' | 'spinner-styles' | 'settings' | 'help';

// Game types for the games menu
export type GameType = 'just-spinner' | 'truth-dare' | 'would-you-rather' | 'trivia' | 'which-one-you-are';

// Menu item interface for consistent structure
export interface MenuItem {
  id: string;
  icon: React.ElementType;
  mode: SidebarMode;
  gameType?: GameType; // For games submenu
  isExternal?: boolean; // For external links
  href?: string; // For external links
}

// Shared menu items array (labels will be set via i18n in Sidebar)
export const menuItems: MenuItem[] = [
  { id: "games", icon: Gamepad2, mode: 'games' },
  { id: "spinnerStyles", icon: Wine, mode: 'spinner-styles' },
  { id: "participants", icon: Users, mode: 'participants' },
  { id: "dice", icon: Dice5, mode: 'dice' },
  { id: "numbers", icon: Hash, mode: 'numbers' },
  { id: "randomNumbers", icon: Shuffle, mode: 'random-numbers' },
  { id: "colors", icon: Palette, mode: 'colors' },
  { id: "binary", icon: SquareCheckBig, mode: 'binary' },
  { id: "help", icon: HelpCircle, mode: 'help' }
];

// Game submenu items (labels will be set via i18n in Sidebar)
export const gameSubmenuItems: MenuItem[] = [
  { id: "just-spinner", icon: Wine, mode: 'games', gameType: 'just-spinner' },
  { id: "truth-dare", icon: SquareCheckBig, mode: 'games', gameType: 'truth-dare' },
  { id: "would-you-rather", icon: Users, mode: 'games', gameType: 'would-you-rather' },
  { id: "trivia", icon: Hash, mode: 'games', gameType: 'trivia' }
];

// Help submenu items (labels will be set via i18n in Sidebar)
export const helpSubmenuItems: MenuItem[] = [
  { id: "help-center", icon: HelpCircle, mode: 'help', href: '/help' },
  { id: "blogs", icon: ExternalLink, mode: 'help', href: 'https://spinnergames.fun/blogs', isExternal: true },
  { id: "privacy-policy", icon: Shield, mode: 'help', href: '/help/privacy-policy' },
  { id: "terms", icon: FileText, mode: 'help', href: '/help/terms' }
];

export default menuItems; 